export default function PropertyBindingCarriedOver(propertyBindingSource, propertyBindingCarriedOver){
		this.getSource=function(){return propertyBindingSource;};
		this.getCarriedOver=function(){return propertyBindingCarriedOver;};
	}